module.exports = __webpack_public_path__ + "static/media/start-level-animation.7c52871a.mp3";